// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"90139286","732":"877816d0"}[chunkId] + ".chunk.js";
};